import { Skeleton, Avatar, Tooltip } from "@mui/material";
import { useGetOne } from "react-admin";
import { Instructor } from "../providers/instructorsProvider";

export const InstructorAvatar = ({
  instructorId,
  size,
  withTooltip,
  borderColor,
}: {
  instructorId: string;
  size: "20px" | "32px" | "40px";
  withTooltip?: boolean;
  borderColor?: string;
}) => {
  const { data, isLoading, error } = useGetOne<Instructor>("instructors", { id: instructorId });
  const sx = borderColor ? { border: `5px solid ${borderColor}`, margin: "-5px" } : {};
  if (isLoading) {
    return <Skeleton component="div" variant="circular" width={size} height={size} sx={sx} />;
  }
  if (error || !data) {
    return (
      <Avatar sx={{ bgcolor: "red", width: size, height: size, ...sx }}>
        <b>!</b>
      </Avatar>
    );
  }
  const avatar = <Avatar alt={data.name} src={data.avatarUrl} sx={{ width: size, height: size, ...sx }} />;
  return withTooltip ? (
    <Tooltip title={data.name} arrow placement="bottom">
      {avatar}
    </Tooltip>
  ) : (
    avatar
  );
};
